import Data from './Data'

export default class DataList extends Array<Data> {
}